import * as Yup from "yup"

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().required("Campo requerido"),
  //menu: Yup.string().required("Campo requerido"),
  url: Yup.mixed()
    .test("type", "Solo imagenes", (value) => {
      console.log("Validation url", value)
      if (value === "" || value === null || value === undefined) {
        console.log("Validation logo", value)
        return true
      }
      var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
      if (regex.test(value)) {
        return true
      }
      return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")
      
    }),
  duration: Yup.number().typeError("Campo debe ser numérico"),
  validity_start_datetime: Yup.string().nullable(),
  validity_end_datetime: Yup.string().nullable(),
  header: Yup.object().shape({
    heading: Yup.string().nullable(),
    subheading: Yup.string().nullable(),
    profileImage: Yup.string().nullable(),
  }),
  active: Yup.boolean().required("Campo requerido")
})